
export const getLoading = state => state.loading;

export const getUserInfo = state => state.userInfo;

export const getFileList = state => state.fileList;

